import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

/**
 * Convert Pydantic v2 validation errors (array of {type, loc, msg, ...})
 * or any nested object into a human-readable string, so downstream code
 * can safely render `err.response.data.detail` in JSX / toast without
 * crashing with "Objects are not valid as a React child".
 */
function normalizeDetail(detail) {
  if (detail == null) return null;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((e) => {
        if (!e) return "";
        if (typeof e === "string") return e;
        if (typeof e.msg === "string") {
          const path = Array.isArray(e.loc) ? e.loc.filter((x) => x !== "body").join(".") : "";
          return path ? `${path}: ${e.msg}` : e.msg;
        }
        try { return JSON.stringify(e); } catch { return String(e); }
      })
      .filter(Boolean)
      .join(" · ");
  }
  if (typeof detail === "object") {
    if (typeof detail.msg === "string") return detail.msg;
    if (typeof detail.message === "string") return detail.message;
    try { return JSON.stringify(detail); } catch { return String(detail); }
  }
  return String(detail);
}

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401 && window.location.pathname !== "/login") {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      window.location.href = "/login";
    }
    // Normalize error detail so it's always a string in downstream handlers,
    // ma preserva la struttura originale in `detail_raw` per usi avanzati (es. conflitti)
    if (err.response?.data && "detail" in err.response.data) {
      const original = err.response.data.detail;
      const normalized = normalizeDetail(original);
      if (typeof original === "object" && original !== null) {
        err.response.data.detail_raw = original;
      }
      if (normalized != null) err.response.data.detail = normalized;
    }
    return Promise.reject(err);
  }
);

export default api;
